import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';
import CustomScrollLink from "./CustomScrollLink";

export default function Header() {
  const [mobileToggle, setMobileToggle] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      if (scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <div
      className={`header-top-fixed one-page-nav ${
        mobileToggle ? 'menu-open menu-open-desk' : ''
      } ${scrolled ? 'fixed-header' : ''}`}
    >
      <div className="container">
        <div className="logo">
          <Link className="navbar-brand" href="#">
            <img
                className="logo-light"
                 alt="Logo"
                src="/logo/logo.png"
            />
          </Link>
        </div>
        <ul className="main-menu">
          <li>
            <CustomScrollLink
                to="home"
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                onClick={() => setMobileToggle(false)}
            >
              Home
            </CustomScrollLink>
          </li>
          <li>
            <CustomScrollLink
                to="about"
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                onClick={() => setMobileToggle(false)}
            >
              About App
            </CustomScrollLink>
          </li>
          <li>
            <CustomScrollLink
                to="engagements"
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                onClick={() => setMobileToggle(false)}
            >
              Engagements
            </CustomScrollLink>
          </li>
          <li>
            <CustomScrollLink
                to="blogs"
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                onClick={() => setMobileToggle(false)}
            >
              Blogs
            </CustomScrollLink>
          </li>
          <li>
            <CustomScrollLink
                to="contactus"
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                onClick={() => setMobileToggle(false)}
            >
              Contact
            </CustomScrollLink>
          </li>
          <li>
            <CustomScrollLink
                to="/device"
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                onClick={() => setMobileToggle(false)}
            >
              Manage Devices
            </CustomScrollLink>
          </li>
        </ul>

        {/*         <ul className="main-menu">
          <li>
            <ScrollLink
              to="home"
              spy={true}
              smooth={true}
              offset={-80}
              duration={500}
              onClick={() => setMobileToggle(false)}
            >
              Home
            </ScrollLink>
          </li>
          <li>
            <ScrollLink
              to="about"
              spy={true}
              smooth={true}
              offset={-80}
              duration={500}
              onClick={() => setMobileToggle(false)}
            >
              About App
            </ScrollLink>
          </li>
          <li>
            <ScrollLink
              to="engagements"
              spy={true}
              smooth={true}
              offset={-80}
              duration={500}
              onClick={() => setMobileToggle(false)}
            >
              Engagements
            </ScrollLink>
          </li>
          <li>
            <ScrollLink
              to="blogs"
              spy={true}
              smooth={true}
              offset={-80}
              duration={500}
              onClick={() => setMobileToggle(false)}
            >
              Blogs
            </ScrollLink>
          </li>
          <li>
            <ScrollLink
              to="contactus"
              spy={true}
              smooth={true}
              offset={-80}
              duration={500}
              onClick={() => setMobileToggle(false)}
            >
              Contact
            </ScrollLink>
          </li>
        </ul>*/}
        {/* Top Menu */}
        <div className="d-flex">

          <button
              className="toggler-menu d-lg-none  "
              onClick={() => setMobileToggle(!mobileToggle)}
          >
            <span/>
          </button>
        </div>
        {/* / */}
      </div>
    </div>
  );
}
